// extracted by mini-css-extract-plugin
module.exports = {"badge-list":"changelog-entry-page_badge-list__cVJZ6","show-markdown-pre":"changelog-entry-page_show-markdown-pre__T6v5N"};